import { Chance } from "chance"
import { ExtractBrand } from "etl/types";

const chance = new Chance();

export const extractBrandFactoryMock = (howMany: number): ExtractBrand[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/api/extract_brands/${index + 1}`,
		"@type": "ExtractBrand",
		id: index + 1,
		actif: "1",
		libelle: chance.word(),
		aw_company_id: chance.integer().toString(),
		hb_id: chance.integer().toString()
	}));
